import React, { useState, useEffect } from "react";
import { Form, Tooltip } from "antd";
import { Table } from "ant-table-extensions";
import FeatherIcon from "feather-icons-react";
import { UserTableStyleWrapper } from "../../pages/style";
import { TableWrapper } from "../../styled";

import { Button } from "../../../components/buttons/buttons";
import { Cards } from "../../../components/cards/frame/cards-frame";

import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { formatPrice, formatSQLDate } from "../../../utils/common";

import { useMutation, useLazyQuery } from "@apollo/client";
import { DELETE_SERVICE_ACTION } from "../../../graphql/AdminMutations";
import { GET_SERVICE_ACTIONS } from "../../../graphql/AdminQueries";

import { deleteServiceAction } from "../../../redux/services/actionCreator";
import displayNotification from "../../reservation/admin/notification/notification";
import { exportujDoExcelu, odkazNaAdmin } from "../../../utils/exportExcel";
import { klikNaRiadok } from "../../../utils/klikNaRiadok";
import Fakturacia, { saDaFakturovat } from "./fakturacia";
import ZbernaFakturaModal from "./zbernaFakturaModal";

import { useHistory } from "react-router-dom";

// Farby stavov. Aby bolo na prvy pohlad vidno, co je otvorene, co schvalene
// a co uz vyfakturovane, a ci vlastnou alebo zbernou fakturou.
//
// Pise sa to inline a nie cez antd Tag zamerne: v tabulke zakaziek je CSS,
// ktore Tagu prepise farbu textu na bielu, a biele na svetlom pozadi sa necita.
// Inline styl prepisat nema co, takze farby sedia vzdy.
const STAVY = {
  open: { pozadie: "#fff7e6", text: "#ad6800", ram: "#ffd591" },
  approved: { pozadie: "#e6f7ff", text: "#0050b3", ram: "#91d5ff" },
  approved_manually: { pozadie: "#e6fffb", text: "#006d75", ram: "#87e8de" },
  invoiced: { pozadie: "#f6ffed", text: "#237804", ram: "#b7eb8f" },
  invoiced_collective: { pozadie: "#f9f0ff", text: "#531dab", ram: "#d3adf7" },
  sent: { pozadie: "#f0f5ff", text: "#1d39c4", ram: "#adc6ff" },
  declined: { pozadie: "#fff1f0", text: "#a8071a", ram: "#ffa39e" },
  deleted: { pozadie: "#f5f5f5", text: "#595959", ram: "#d9d9d9" },
};

const ZnackaStavu = ({ stav, popis }) => {
  const f = STAVY[stav] || STAVY.deleted;
  return (
    <span
      style={{
        display: "inline-block",
        minWidth: 140,
        textAlign: "center",
        padding: "2px 12px",
        borderRadius: 12,
        border: `1px solid ${f.ram}`,
        background: f.pozadie,
        color: f.text,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: "20px",
        whiteSpace: "nowrap",
      }}
    >
      {popis}
    </span>
  );
};


const List = (props) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const {
    inputData,
    graphqlVariables,
    checkedStatus,
    total,
    sendPageNumberToGrid,
    pageNumberToGrid,
    downloadCsvStatus,
    buttons,
    limit,
  } = props;
  const displayExportPdf = checkedStatus === "open" ? true : false;
  const [form] = Form.useForm();

  const [state, setState] = useState({
    editVisible: false,
    update: {},
    newIncomeModalState: false,
  });

  // Zaskrtnute zakazky drzime ako cele zaznamy, nie len ako kluce. Vdaka tomu
  // sa da zaskrtnut nieco na prvej strane, prehodit na druhu a dokliknut tam,
  // bez toho aby vyber po prelistovani stichol zmizol.
  const [vybrane, setVybrane] = useState([]);
  const [detailFaktury, setDetailFaktury] = useState(null);

  // Po prenacitani dat (napriklad po fakturacii) vyhodime z vyberu to, co sa
  // uz fakturovat neda. Inak by v liste visel pocet, ktory nic nerobi.
  useEffect(() => {
    if (!Array.isArray(inputData)) return;
    setVybrane((predosle) =>
      predosle.filter((z) => {
        const novy = inputData.find((i) => Number(i.id) === Number(z.id));
        return novy ? saDaFakturovat(novy) : saDaFakturovat(z);
      })
    );
  }, [inputData]);

  const prepniZakazku = (zaznam, zaskrtnute) => {
    setVybrane((predosle) => {
      const bez = predosle.filter((z) => Number(z.id) !== Number(zaznam.id));
      return zaskrtnute ? [...bez, zaznam] : bez;
    });
  };

  // delete service action
  const [triggerDeleteItem] = useMutation(DELETE_SERVICE_ACTION, {
    variables: graphqlVariables,
  });

  const history = useHistory();

  const routeChange = (item) => {
    const detailPath = `/admin/service/action/${item.id}`;
    history.push(detailPath);
  };

  const [formReadonly, setFormReadonly] = useState(true);
  const [selectedItem, setSelectedItem] = useState({});
  const [
    fetchAllServiceActions,
    { loading: exportLoading },
  ] = useLazyQuery(GET_SERVICE_ACTIONS, { fetchPolicy: "network-only" });

  const tableData = [];
  const modalData = [];
  console.log("inputData", inputData);
  if (Array.isArray(inputData)) {
    inputData.forEach((item) => {
      const {
        id,
        branchOffice,
        car,
        carOwner,
        date,
        status,
        total,
        invoice_number,
        exportBlDate,
        exportBlStatus,
        downloadCsvStatus,
        ayvens_contract_number,
      } = item;
      const deleteDisabled = invoice_number ? true : false;
      const link = "/admin/car/edit/" + car?.id;
      const serviceDetailLink = "/admin/service/action/" + id;
      // Jeden stlpec na cislo dokladu, bez ohladu na to, ci je faktura vlastna
      // alebo zberna. Pri zbernej je cislo klikatelne a otvori doklad: inak by
      // sa k PDF nedalo dostat vobec.
      const cisloDokladu = item.invoiceId ? (
        <Button
          type="link"
          size="small"
          style={{ padding: 0, height: "auto", fontWeight: 600 }}
          title="Otvoriť zbernú faktúru"
          onClick={(e) => {
            e.stopPropagation();
            setDetailFaktury(Number(item.invoiceId));
          }}
        >
          {invoice_number}
        </Button>
      ) : (
        invoice_number
      );
      let invoiceNumber = cisloDokladu;
      if (exportBlStatus === true) {
        invoiceNumber = (
          <ul>
            <span>{cisloDokladu}</span>
            <p>{formatSQLDate(exportBlDate)}</p>
          </ul>
        );
      }
      tableData.push({
        // Cislom, nie tak ako chodi z GraphQL. Tam je id typu ID, cize
        // retazec, a selectedRowKeys drzim ako cisla. Ked sa typy rozisli,
        // antd si zaskrtnuty riadok nenasiel: stvorcek sa po kliknuti hned
        // odznacil a pri dalsom kliku zmizlo aj predosle oznacenie.
        key: Number(id),
        id: (
          <a key={id} href={serviceDetailLink}>
            <span className={`status-text`}>{id}</span>
          </a>
        ),
        licence_plate: (
          <a key={id} href={link}>
            <span className={`status-text`}>{car?.licence_plate}</span>
          </a>
        ),
        date: formatSQLDate(date),
        status: (
          <ZnackaStavu
            stav={status}
            popis={t("serviceActions.tableList.statuses." + status)}
          />
        ),
        owner: carOwner?.company,
        branchOffice: branchOffice?.company,
        total: formatPrice(total),
        invoiceNumber: invoiceNumber,
        zaznam: item,
        action: (
          <div className="table-actions" onClick={(e) => e.stopPropagation()}>
            <>
              <Button
                onClick={() => routeChange(item)}
                className="btn-icon"
                type="info"
                to="#"
                shape="circle"
              >
                <FeatherIcon icon="edit" size={16} />
              </Button>
              <Button
                onClick={() => deleteItem(item, "delete")}
                className="btn-icon"
                type="info"
                to="#"
                shape="circle"
                disabled={deleteDisabled}
              >
                <FeatherIcon icon="trash-2" size={16} />
              </Button>
            </>
          </div>
        ),
      });
    });
  }

  const deleteItem = (data) => {
    const id = Number(data.id);
    const confirm = window.confirm(t("serviceActions.tableList.delete"));
    if (confirm) {
      const variables = {
        ...graphqlVariables,
        id: id,
      };
      triggerDeleteItem({ variables }).then(({ data }) => {
        const response = data?.deleteServiceAction;
        let type = "success";
        const message = t("backend.notifications.update");
        let desc = t("backend.notifications.success.recordDelete");
        if (response.sucessful) {
          dispatch(deleteServiceAction(id));
        } else {
          type = "error";
          desc = t("backend.notifications.error.recordDelete");
        }
        displayNotification(type, message, desc);
      });
    }
  };

  const STLPCE_EXPORTU = [
    { kluc: "cislo", popis: "Č. zákazky", sirka: 14, typ: "odkaz" },
    { kluc: "ecv", popis: "EČV", sirka: 14, typ: "odkaz" },
    { kluc: "vozidlo", popis: "Vozidlo", sirka: 28 },
    { kluc: "stav", popis: "Stav", sirka: 16 },
    { kluc: "datum", popis: "Dátum", sirka: 12, typ: "datum" },
    { kluc: "majitel", popis: "Majiteľ", sirka: 30 },
    { kluc: "pneuservis", popis: "Pneuservis", sirka: 20 },
    { kluc: "spolu", popis: "Spolu", sirka: 14, typ: "penize" },
    { kluc: "faktura", popis: "Číslo faktúry", sirka: 16 },
  ];

  const handleDownload = async () => {
    try {
      // Export berie presne to, co je v zozname vyfiltrovane, len bez
      // stranovania. Predtym ignoroval filtre aj hladany text.
      const variables = {
        ...(props.premenneDoExportu || {}),
        tokenGet: graphqlVariables?.tokenGet,
        status: checkedStatus || undefined,
        offset: 0,
        limit: 0,
      };
      const { data } = await fetchAllServiceActions({ variables });
      const records = data?.getServiceActions?.records || [];
      await exportujDoExcelu({
        nazovSuboru: "zakazky",
        nazovHarku: "Zákazky",
        stlpce: STLPCE_EXPORTU,
        riadky: records.map((z) => ({
          cislo: {
            text: z?.id || "",
            url: odkazNaAdmin(`/admin/service/action/${z?.id}`),
          },
          ecv: {
            text: z?.car?.licence_plate || "",
            url: z?.car?.id ? odkazNaAdmin(`/admin/car/edit/${z.car.id}`) : null,
          },
          vozidlo: z?.car?.type,
          stav: t("serviceActions.tableList.statuses." + z?.status),
          datum: z?.date,
          majitel: z?.carOwner?.company,
          pneuservis: z?.branchOffice?.company,
          spolu: z?.total,
          faktura: z?.invoice_number,
        })),
        info: {
          Stav: checkedStatus || "všetky",
          "Hľadaný text": props.premenneDoExportu?.search || "",
        },
      });
    } catch (e) {
      console.error("Export failed", e);
    } finally {
    }
  };
  const defaultPageSize = limit;

  return (
    <Cards headless>
      <UserTableStyleWrapper>
        {/* {displayExportPdf && displayExportPdf === true && <Button>1111</Button>} */}
        <Button
          className="btn-export"
          onClick={handleDownload}
          type="primary"
          disabled={exportLoading}
        >
          {exportLoading ? "Pripravujem export..." : "Export do Excelu"}
        </Button>
        {buttons}

        {/* Fakturacia je tu, nie na vlastnej obrazovke: zakazky sa vyfiltruju
            vyssie, zaskrtnu v tabulke a odtialto sa z nich vystavi doklad. */}
        <Fakturacia
          vybrane={vybrane}
          onVycistit={() => setVybrane([])}
          onHotovo={() => {
            setVybrane([]);
            if (typeof props.onPoFakturacii === "function") props.onPoFakturacii();
          }}
        />

        <TableWrapper className="table-responsive">
          <Table
            scroll={{ x: "max-content" }}
            dataSource={tableData}
            loading={props.loading}
            rowSelection={{
              selectedRowKeys: vybrane.map((z) => Number(z.id)),
              // Zaskrtnut sa da len to, co sa naozaj vyfakturovat da. To iste
              // overuje aj backend v transakcii, toto je len preto, aby sa
              // clovek nedoklikal k chybe.
              getCheckboxProps: (record) => ({
                disabled: !saDaFakturovat(record?.zaznam),
              }),
              // Ked sa zaskrtnut neda, nech je aspon vidno preco. Tooltip musi
              // byt na obalovacom spane, disabled checkbox sam o sebe myslou
              // udalost nepusti.
              renderCell: (hodnota, record, poradie, povodnyPrvok) => {
                const zaznam = record?.zaznam;
                if (saDaFakturovat(zaznam)) return povodnyPrvok;
                const dovod =
                  zaznam?.invoiceId || zaznam?.invoice_number
                    ? "Táto zákazka už faktúru má."
                    : "Zaškrtnúť sa dajú len schválené zákazky.";
                return (
                  <Tooltip title={dovod}>
                    <span style={{ display: "inline-block" }}>
                      {povodnyPrvok}
                    </span>
                  </Tooltip>
                );
              },
              onSelect: (record, zaskrtnute) =>
                record?.zaznam && prepniZakazku(record.zaznam, zaskrtnute),
              onSelectAll: (zaskrtnute, vsetky, zmenene) =>
                (zmenene || []).forEach(
                  (r) => r?.zaznam && prepniZakazku(r.zaznam, zaskrtnute)
                ),
            }}
            rowClassName={() => "riadok-klikatelny"}
            onRow={(record) =>
              klikNaRiadok({
                cesta: `/admin/service/action/${record?.zaznam?.id}`,
                akcia: () => record?.zaznam && routeChange(record.zaznam),
              })
            }
            columns={getTableColumns(t)}
            pagination={{
              defaultPageSize: defaultPageSize,
              total: total,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} ${t("common.from")} ${total} ${t(
                  "common.items"
                )}`,
              position: ["topLeft", "bottomLeft"],
              onChange: sendPageNumberToGrid,
              current: pageNumberToGrid || 1,
            }}
            onChange={(pagination) => {
              console.log("Selected Row:", pagination);
              const data = {
                pageNumber: pagination.current,
                pageSize: pagination.pageSize,
              };
              sendPageNumberToGrid(data);
            }}
          />
        </TableWrapper>
      </UserTableStyleWrapper>
      {detailFaktury && (
        <ZbernaFakturaModal
          invoiceId={detailFaktury}
          onClose={() => setDetailFaktury(null)}
          onZmena={() => {
            if (typeof props.onPoFakturacii === "function") props.onPoFakturacii();
          }}
        />
      )}
    </Cards>
  );
};

const getTableColumns = (t) => {
  return [
    {
      title: t("serviceActions.tableList.licencePlate"),
      dataIndex: "licence_plate",
      key: "licence_plate",
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("serviceActions.tableList.status"),
      dataIndex: "status",
      key: "status",
      align: "center",
    },
    {
      title: t("serviceActions.tableList.date"),
      dataIndex: "date",
      key: "date",
    },
    {
      title: t("serviceActions.tableList.carOwner"),
      dataIndex: "owner",
      key: "owner",
    },
    {
      title: t("serviceActions.tableList.branchOffice"),
      dataIndex: "branchOffice",
      key: "branchOffice",
    },
    {
      title: t("serviceActions.tableList.total"),
      dataIndex: "total",
      key: "total",
    },
    {
      title: t("serviceActions.tableList.invoiceNumber"),
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      align: "center",
    },
    {
      title: t("common.actions"),
      dataIndex: "action",
      key: "action",
      width: "90px",
    },
  ];
};

export default List;
